export const Pond = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="18"
         height="18"
         viewBox="0 0 18 18"
         fill="none"
         {...props}
      >
         <g opacity="0.7" clipPath="url(#clip0_7028_2951)">
            <path
               d="M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM12.75 12.75H5.25V11.25H12.75V12.75ZM12.75 9H5.25V7.5H12.75V9ZM12.75 5.25H5.25V3.75H12.75V5.25Z"
               fill="currentColor"
            ></path>
         </g>
         <defs>
            <clipPath id="clip0_7028_2951">
               <rect width="18" height="18" fill="currentColor"></rect>
            </clipPath>
         </defs>
      </svg>
   )
}
